module.exports = __webpack_public_path__ + "media/Kitchen.5dbb6bc0.mp3";